<template>
  <v-layout>
    <v-flex xs12 sm10 offset-sm1 >
      <v-card>
        <v-card-title class="primary justify-center">
          <v-container pa-0>
            <v-layout fluid row wrap>
              <v-flex xs12>
                <v-btn
                  v-on:click="redireccion"
                  absolute
                  dark
                  small
                  fab
                  center
                  right
                  class="accent"
                  >
                  <v-icon>add</v-icon>
                </v-btn>
              <h6 class="white--text text-xs-center">Facturas</h6>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm2>
                  <v-dialog
                    persistent
                    v-model="menu"
                    lazy
                    full-width
                  >
                    <v-text-field
                      dark
                      slot="activator"
                      label="Desde"
                      v-model="desde"
                      prepend-icon="event"
                      data-vv-delay="100"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="desde" scrollable>
                      <template slot-scope="{ save, cancel }">
                        <v-card-actions>
                          <v-btn flat primary @click.native="cancel()">Cancelar</v-btn>
                          <v-btn flat primary @click.native="save(), filtrarfechainicio()">Aceptar</v-btn>
                        </v-card-actions>
                      </template>
                    </v-date-picker>
                  </v-dialog>
              </v-flex>
              <v-flex xs12 sm2>
                <v-dialog
                    persistent
                    v-model="menu2"
                    lazy
                    full-width
                  >
                    <v-text-field
                      dark
                      slot="activator"
                      label="Hasta"
                      v-model="hasta"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="hasta" scrollable >
                      <template slot-scope="{ save, cancel }">
                        <v-card-actions>
                          <v-btn flat primary @click.native="cancel()">Cancelar</v-btn>
                          <v-btn flat primary @click.native="save(), filtrarfechafin()">Aceptar</v-btn>
                        </v-card-actions>
                      </template>
                    </v-date-picker>
                  </v-dialog>
              </v-flex>
              <v-flex xs12 sm2>
              <v-select
                v-bind:items="rutas"
                v-model="ruta"
                itemText="nombre"
                label="Rutas"
                single-line
                bottom
                dark
                @change="filtrarruta($event)"
              >
              </v-select>
          </v-flex>
              <v-flex xs12 sm2>
              <v-select
                v-bind:items="usuarios"
                v-model="usuario"
                itemText="username"
                label="Usuarios"
                single-line
                bottom
                dark
                @change="filtrarusuario($event)"
              >
              </v-select>
          </v-flex>
              <v-flex xs12 sm2>
                <v-text-field dark
                    v-model="search"
                    name="buscar"
                    label="Buscar"
                    @keyup.enter="buscarfactura"
            >

                </v-text-field>
          </v-flex>
            </v-layout>
          </v-container>
        </v-card-title>
          <v-flex style="overflow-x: auto">
             <table class="table">
              <tr>
                <th></th>
                <th></th>
                <th>Cliente</th>
                <th>Fecha</th>
                <th>Total</th>
                <th>Dirección</th>
              </tr>
            <tbody>
              <tr v-for="factura in facturas.results">
                <td>
                  <v-btn icon class="red--text text--darken-2" @click="eliminar(factura)">
                    <v-icon>delete</v-icon>
                  </v-btn></td>
                <td>
                  <v-btn icon class="blue--text text--darken-2" @click="editarfactura(factura)">
                    <v-icon>edit</v-icon>
                  </v-btn></td>
                <td class="text-xs-center" :class=" factura.serie_fel ? 'blue--text' : 'black--text'">{{factura.cliente_name}}</td>
                <td class="text-xs-center" :class=" factura.serie_fel ? 'blue--text' : 'black--text'">{{factura.fecha | formatDate}}</td>
                <td class="text-xs-center" :class=" factura.serie_fel ? 'blue--text' : 'black--text'">Q. {{factura.total.toFixed(2)}}</td>
                <td class="text-xs-center" :class=" factura.serie_fel ? 'blue--text' : 'black--text'">{{factura.direccion_completa}}</td>
              </tr>
            </tbody>
          </table>
          </v-flex>
         <v-card-actions class="justify-center">
          <v-layout row justify-center align-center>
             <v-btn fab dark small primary @click="prev(facturas.previous)" v-if="facturas.previous">
              <v-icon dark>skip_previous</v-icon>
            </v-btn>
             <v-btn fab dark small primary @click="next(facturas.next)" v-if="facturas.next">
            <v-icon>skip_next</v-icon>
          </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-flex>


  </v-layout>
</template>

<script>
  export default {
    created: function () {
      this.$store.dispatch('getrutas')
      this.$store.dispatch('getusuarios')
      if (this.$store.state.ruta.nombre !== null || this.$store.state.usuario.username !== null || this.$store.getters.getdesde || this.$store.getters.gethasta) {
        this.$store.dispatch('actualizarfacturas', {ruta: this.$store.state.ruta.nombre,
          usuario: this.$store.state.usuario.username,
          fecha_minima: this.$store.getters.getdesde,
          fecha_maxima: this.$store.getters.gethasta})
      } else {
        this.$store.dispatch('actualizarfacturas')
      }
    },
    data () {
      return {
        menu: false,
        menu2: false,
        fechainicio: '',
        fechafin: '',
        search: ''
      }
    },
    methods: {
      redireccion: function () {
        this.$store.commit('resetfactura')
        this.$router.push('/facturaadd')
      },
      eliminar (factura) {
        let r = confirm(' esta seguro que desea eliminar ' + factura.cliente_name)
        if (r === true) {
          this.$store.dispatch('eliminarfactura', factura)
        }
      },
      editarfactura: function (factura) {
        this.$store.commit('resetfactura')
        this.$store.commit('actualizarfactura', factura)
        this.$store.commit('actualizarestadofactura', true)
        this.$store.dispatch('getcliente', factura.cliente)
        factura.lineas.map(linea => {
          this.$store.commit('actualizarlinea', linea)
        })
        this.$router.push('facturaadd')
      },
      filtrarfechafin: function () {
        console.log(this.$store.getters.gethasta)
        console.log(this.$store.getters.getdesde)
        this.$store.dispatch('actualizarfacturas', {fecha_maxima: this.$store.getters.gethasta,
          ruta: this.$store.getters.getruta.nombre ? this.$store.getters.getruta.nombre : '',
          usuario: this.$store.getters.getusuario.username ? this.$store.getters.getusuario.username : '',
          fecha_minima: this.$store.getters.getdesde})
      },
      filtrarfechainicio: function () {
        console.log(this.$store.getters.gethasta)
        console.log(this.$store.getters.getdesde)
        this.$store.dispatch('actualizarfacturas', {fecha_maxima: this.$store.getters.gethasta,
          ruta: this.$store.getters.getruta.nombre ? this.$store.getters.getruta.nombre : '',
          usuario: this.$store.getters.getusuario.username ? this.$store.getters.getusuario.username : '',
          fecha_minima: this.$store.getters.getdesde})
      },
      filtrarruta: function (ruta) {
        this.$store.dispatch('actualizarfacturas', {fecha_maxima: this.$store.getters.gethasta,
          ruta: ruta.nombre,
          usuario: this.$store.getters.getusuario.username ? this.$store.getters.getusuario.username : '',
          fecha_minima: this.$store.getters.getdesde})
      },
      filtrarusuario: function (usuario) {
        this.$store.dispatch('actualizarfacturas', {fecha_maxima: this.$store.getters.gethasta,
          usuario: usuario.username,
          ruta: this.$store.getters.getruta.nombre ? this.$store.getters.getruta.nombre : '',
          fecha_minima: this.$store.getters.getdesde})
      },
      buscarfactura: function () {
        this.$store.dispatch('actualizarfacturas', {search: this.search})
      },
      next: function (dato) {
        this.$store.dispatch('actualizarfacturas2', dato)
      },
      prev: function (dato) {
        this.$store.dispatch('actualizarfacturas2', dato)
      }
    },
    computed: {
      headers: function () {
        return this.$store.getters.list_facturas_headers
      },
      facturas: function () {
        return this.$store.getters.listadofacturas
      },
      rutas: function () {
        return this.$store.getters.rutas
      },
      usuarios: function () {
        return this.$store.getters.usuarios
      },
      ruta: {
        get: function () {
          return this.$store.getters.getruta
        },
        set: function (dato) {
          this.$store.commit('actualizarruta', dato)
        }
      },
      usuario: {
        get: function () {
          return this.$store.getters.getusuario
        },
        set: function (dato) {
          this.$store.commit('actualizarusuario', dato)
        }
      },
      desde: {
        get: function () {
          return this.$store.getters.getdesde
        },
        set: function (dato) {
          this.$store.commit('actualizardesde', dato)
        }
      },
      hasta: {
        get: function () {
          return this.$store.getters.gethasta
        },
        set: function (dato) {
          this.$store.commit('actualizarhasta', dato)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Factura.vue?78990086